export const adGroupFormInputs = {
  name: '',
};
